<template>
  <div class="noThing" >
    <img :style="{'margin-top': top}" src="../assets/img/nothing.png" alt="">
    <p>暂无内容</p>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    },
    props: {
      top: {
        type: String,
        default: '150px'
      }
    }
  }
</script>

<style scoped>
  .noThing{
    width: 100%;
    height: 272px;
    text-align: center;
  }
  .noThing img{
    width: 200px;
    margin-top: 150px;

  }
  .noThing p {
    margin-top: 20px;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/common/nothing.vue